// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BetGroupLabelWithLineClassName = 'label-line';
const Line = styled.div`
  height: 1px;
  flex-grow: 10000;
`;

const Text = styled.div`
  z-index: 2;
  padding-right: 1em;
  flex-grow: 1;
`;

type BetGroupLabelWithLineProps = {
  className?: string;
  label: string;
};

const BetGroupLabelWithLine = ({ className, label }: BetGroupLabelWithLineProps) => (
  <Wrap className={className}>
    <Text className="label-text">{label}</Text>
    {label ? <Line className={BetGroupLabelWithLineClassName} /> : null}
  </Wrap>
);

export default React.memo<BetGroupLabelWithLineProps>(BetGroupLabelWithLine);
